import { buildEnglishLabel } from "./labelBuilder";
import type { DataLabelEntry, DataLabelResult } from "./types";

function fallbackLabel(index: number): string {
  return `Generated dataset ${index}`;
}

export function sanitizeSingleLabel(
  rawDescription: string | undefined,
  fallbackIndex: number
): string {
  const label = buildEnglishLabel(rawDescription);
  if (!label) {
    return fallbackLabel(fallbackIndex);
  }
  return label;
}

export function buildEnglishLabels(entries: DataLabelEntry[]): DataLabelResult[] {
  const preUniqueResults: DataLabelResult[] = entries.map((entry, index) => ({
    dataId: entry.dataId,
    label: sanitizeSingleLabel(entry.rawDescription, index + 1),
  }));

  const seen = new Map<string, number>();

  return preUniqueResults.map((item) => {
    const key = item.label.toLowerCase();
    const count = (seen.get(key) || 0) + 1;
    seen.set(key, count);

    if (count === 1) {
      return item;
    }

    return {
      ...item,
      label: `${item.label} ${count}`,
    };
  });
}
